import { SurfaceType } from '@jms/model';
import type { SurfaceTypeDefinition } from '../../core/runtime/surfaces/surface.definition';
import { SURFACE_SCHEMA_SLOTS } from '../../core/runtime/surfaces/surface.schema.slots';

// Embedded fixed-width entity panel inside the inbox shell. Same authoring
// shape as manage (summary + tabs); the host renders narrower with a header
// block. Patch-on-blur autosave.
export const inboxSurface = {
  id: SurfaceType.Inbox,
  saveStrategy: 'patch',
  defaultFieldMode: 'edit',
  viewStatePersistence: 'url',
  slots: SURFACE_SCHEMA_SLOTS[SurfaceType.Inbox],
} as const satisfies SurfaceTypeDefinition<SurfaceType.Inbox>;
